import {
  createSystem,
  defaultConfig,
  defineConfig,
  defineRecipe,
  defineSlotRecipe,
} from "@chakra-ui/react"

export const buttonRecipe = defineRecipe({
  variants: {
    variant: {
      primary: {
        backgroundColor: "main",
        color: "light",
        _hover: {
          backgroundColor: "light",
          color: "main",
          borderColor: "main",
        },
        _disabled: {
          backgroundColor: "main",
          _hover: {
            backgroundColor: "main",
          },
        },
      },
      secondary: {
        backgroundColor: "white",
        color: "main",
        borderColor: "main",
        _hover: {
          backgroundColor: "main",
          borderColor: "white",
          color: "white",
        },
        _disabled: {
          backgroundColor: "dim",
          _hover: {
            backgroundColor: "dim",
          },
        },
      },
      danger: {
        backgroundColor: "danger",
        color: "light",
        _hover: {
          backgroundColor: "white",
          color: "#E32727",
          borderColor: "#E32727",
        },
      },
    },
  },
})


export const tabsRecipe = defineSlotRecipe({
  slots: ["trigger"],
  variants: {
    variant: {
      outline: {
        trigger: {
          _selected: {
            borderTopRadius: "5px !important",
            color: "main !important",
          }
        }
      }
    }
  },
})


const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        main: { value: "var(--main)" },
        secondary: { value: "var(--secondary)" },
        tertiary: { value: "var(--tertiary)" },
        success: { value: "#48BB78" },
        danger: { value: "#E53E3E" },
        light: { value: "#FAFAFA" },
        dark: { value: "#1A202C" },
        darkSlate: { value: "#252D3D" },
        dim: { value: "#A0AEC0" },
        white: { value: "#ffffff" },
        black: { value: "#000000" },
        mainOpacity: { value: "color-mix(in srgb, var(--main) 80%, transparent)" }
      },
    },
    slotRecipes: {
      tabs: tabsRecipe,
    },
    recipes: {
      button: buttonRecipe,
    },
  },
  globalCss: {
    "body": {
      fontFamily: "Gudea"
    },
    ".prx_h1": {
      color: "main !important",
    },
    ".lg-thumb-item.active": {
      borderColor: "main !important",
    },
    ".lg-thumb-item:hover": {
      borderColor: "main !important",
    },
    ".grecaptcha-badge": { 
      visibility: "hidden", 
    },
  },
})

export const system = createSystem(defaultConfig, config)
